/**
 * 联系人管理标签数据接口文档
 */
import { Method } from '../core';
import { API, SOURCE } from '../config';

const api = API;

export default {
  moveTo: {
    url: `${api}/rest/v1/signflow/moveTo`,
    method: Method.POST,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      userFolderId: {
        $type: String
      },
      participantId: {
        $type: String
      }
    }
  },
  // 重命名文件夹 /rest/v1/userfolder/rename
  rename: {
    url: `${api}/rest/v1/userfolder/rename`,
    method: Method.POST,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      userFolderId: {
        $type: String
      },
      userFolderName: {
        $type: String
      }
    }
  },
  // 获取文件夹列表 /rest/v1/userfolder/query
  getFileList: {
    url: `${api}/rest/v1/userfolder/query`,
    method: Method.GET,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      accountUid: {
        $type: String,
        $required: false
      },
      needCount: {
        $type: Boolean,
        $default: true
      }
    }
  },
  
  // 添加 文件夹 /rest/v1/userfolder/add
  addFile: {
    url: `${api}/rest/v1/userfolder/add`,
    method: Method.POST,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      userFolderName: {
        $type: String
      }
    }
  },

//  删除文件夹
  delFile: {
    url: `${api}/rest/v1/userfolder/delete`,
    method: Method.POST,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      userFolderId: {
        $type: String
      }
    }
  },
  
  // 获取文档数量
  count: {
    url: `${api}/rest/v1/signflow/count`,
    method: Method.GET,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      accountUid: {
        $type: String
      }
    }
  },
  
  // 分页获取文档列表
  getMyDocList: {
    url: `${api}/rest/v1/signflow/list`,
    method: Method.GET,
    body: {
      page: {
        $type: Number,
        $required: true
      },
      pageSize: {
        $type: Number,
        $required: true
      },
      status: {
        $type: Number,
        $required: false
      },
      docName: {
        $type: String,
        $required: false
      },
      senderKeyInfo: {
        $type: String,
        $required: false
      },
      receiverKeyInfo: {
        $type: String,
        $required: false
      },
      needTotalCount: {
        $type: Boolean
      },
      userFolderId: {
        $type: String
      },
      source: {
        $type: String,
        $default: SOURCE
      },
      showReceivers: {
        $type: Number
      }
    }
  },
  
  // 下载文档
  downloadMyDoc: {
    url: `${api}/rest/v1/signflow/download`,
    method: Method.GET,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  
  // 删除文档
  deleteMyDoc: {
    url: `${api}/rest/v1/signflow/delete`,
    method: Method.DELETE,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },

  // 移出文档
  moveOutMyDoc: {
    url: `${api}/rest/v1/signflow/moveOut`,
    method: Method.POST,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      userFolderId: {
        $type: String
      },
      participantId: {
        $type: String
      }
    }
  },

  // 退回文档
  rejectMyDoc: {
    url: `${api}/rest/v1/signflow/reject`,
    method: Method.POST,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      reason: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  
  // 撤回文档
  revokeMyDoc: {
    url: `${api}/rest/v1/signflow/revoke`,
    method: Method.POST,
    body: {
      flowId: {
        $type: String,
        $required: true
      },
      reason: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  
  // 催签文档
  remindMyDoc: {
    url: `${api}/rest/v1/signflow/remind`,
    method: Method.POST,
    body: {
      flowId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  
  // 获取他人账户信息
  getOtherInfo: {
    url: `${api}/rest/v1/account/info/other`,
    method: Method.GET,
    body: {
      account: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  
  // 转签
  transferMyDoc: {
    url: `${api}/rest/v1/signflow/transfer`,
    method: Method.POST,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      transferAccountUid: {
        $type: String,
        $required: false
      },
      transferAccount: {
        $type: String,
        $required: true
      },
      transferName: {
        $type: String,
        $required: false
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  
  // 文档详情
  detailMyDoc: {
    url: `${api}/rest/v1/signflow/detail`,
    method: Method.GET,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  
  // 获取文档合同内容
  getOsskeyImage: {
    url: `${api}/rest/v1/file/image`,
    method: Method.GET,
    body: {
      osskey: {
        $type: String,
        $required: false
      },
      pageNum: {
        $type: String,
        $required: false
      },
      imageSize: {
        $type: Number,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  
  // 查询剩余签署次数
  getBillingInfo: {
    url: `${api}/rest/v1/account/billingInfo`,
    method: Method.GET,
    body: {
      accountInfo: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/resource-api/api/myDoc.js